// documentRenderer.js
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Tooltip from '@mui/material/Tooltip';

export const RenderDocumentColumn = (value) => {
    if (!value || value.length <= 2) return null;

    const fileExtension = value.split('.').pop().toLowerCase();
    const isImage = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(
        fileExtension
    );
    const isPDF = fileExtension === 'pdf';

    const downloadLinkProps = {
        href: value,
        download: true,
        style: { textDecoration: 'none', display: 'inline-block' },
        rel: 'noopener noreferrer'
    };

    if (isImage) {
        return (
            <Tooltip title="Click to download" arrow>
                <a {...downloadLinkProps}>
                    <img
                        src={value}
                        className="gridImg"
                        alt="document"
                        height={40}
                        width={40}
                        style={{
                            cursor: 'pointer',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            padding: '2px'
                        }}
                    />
                </a>
            </Tooltip>
        );
    }

    if (isPDF) {
        return (
            <Tooltip title="Download PDF" arrow>
                <a
                    {...downloadLinkProps}
                    style={{ ...downloadLinkProps.style, padding: '8px' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <CloudDownloadIcon
                            color="primary"
                            style={{ marginRight: '4px' }}
                        />
                        <span style={{ fontSize: '12px' }}>PDF</span>
                    </div>
                </a>
            </Tooltip>
        );
    }

    return (
        <Tooltip title={`Download ${fileExtension.toUpperCase()} file`} arrow>
            <a {...downloadLinkProps}>
                <CloudDownloadIcon color="primary" />
            </a>
        </Tooltip>
    );
};
